<template lang="pug">
  .profile-page__main
    .profile-page__body
      quota-house-editor-modal(
      v-if="showHouseEditor"
      @close="showHouseEditor = false"
      :houses="houses"
      :current-house="currentHouse"
      :quota="quotaId"
      @add-quotas-house="addQuotasHouse"
      )
      quota-capacity-modal(
      v-if="showCapacityModal"
      @close="showCapacityModal = false"
      :mask="capacityMask"
      :current-value="fields.capacity"
      :quota-id="quotaId"
      @on-change-capacity="changeCapacity"
      )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Общая информация
        .profile-section__body
          .form
            .form__elem
              .form-elem.form-elem_horizontal(
                :class="{'form-elem_error' : fieldsErrors.name.value}"
              )
                .form-elem__title Название квоты
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="fields.name"
                  @input="resetError('name')"
                  )
            .form__elem.form__elem_short
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error' : fieldsErrors.emptyCapacity.value || fieldsErrors.wrongCapacity.value}"
              )
                .form-elem__title Количество людей
                .form-elem__body
                  lockable-input(
                  v-if="mode === 'edit'"
                  @on-button-click="showCapacityModal = true"
                  :value="fields.capacity"
                  )
                  input.input.input_full(
                  v-else
                  maxlength="128"
                  v-model="fields.capacity"
                  @input="resetError('emptyCapacity,wrongCapacity')"
                  ref="capacity"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':ageError}"
              )
                .form-elem__title Диапазон возраста участников смены
                .form-elem__body
                  .double-input
                    input.input.input_full(
                    maxlength="128"
                    v-model="fields.ageFrom"
                    @input="resetError('emptyAge,minAge,maxAge,wrongAge')"
                    ref="ageFrom"
                    )
                    span.double-input__separator -
                    input.input.input_full(
                    maxlength="128"
                    v-model="fields.ageTo"
                    @input="resetError('emptyAge,minAge,maxAge,wrongAge')"
                    ref="ageTo"
                    )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Пол ребенка
                .form-elem__body
                  .form-elem-list
                    .form-elem-list__item
                      label.input-item
                        .input-item__input
                          .radio
                            input.radio__input(
                            type="radio"
                            v-model="fields.gender"
                            value="null"
                            )
                            .radio__icon
                        .input-item__body
                          .input-item__text Все
                    .form-elem-list__item
                      label.input-item
                        .input-item__input
                          .radio
                            input.radio__input(
                            type="radio"
                            v-model="fields.gender"
                            value="true"
                            )
                            .radio__icon
                        .input-item__body
                          .input-item__text Мужской
                    .form-elem-list__item
                      label.input-item
                        .input-item__input
                          .radio
                            input.radio__input(
                            type="radio"
                            v-model="fields.gender"
                            value="false"
                            )
                            .radio__icon
                        .input-item__body
                          .input-item__text Женский
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Дополнительные параметры
        .profile-section__body
          .form
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Оплата через эквайринг
                .form-elem__body
                  .form-elem-list
                    .form-elem-list__item
                      label.input-item
                        .input-item__input
                          .checkbox
                            input.checkbox__input(
                            type="checkbox"
                            v-model="fields.acquiringEnabled"
                            )
                            .checkbox__icon
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Проверка по месту регистрации
                .form-elem__body
                  activated-select(
                  :placeholder="'Выберите районы'"
                  :options="regionAreas"
                  :multiple="true"
                  :close-on-select="false"
                  :allow-empty="false"
                  :select-value="fields.registrationAreas"
                  :checkbox-value="fields.registrationAreasCheckbox"
                  :select-field="'registrationAreas'"
                  :checkbox-field="'registrationAreasCheckbox'"
                  @checkbox-change="activatedSelectChange"
                  @select-change="activatedSelectChange"
                  )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Проверка по месту жительства
                .form-elem__body
                  activated-select(
                  :placeholder="'Выберите районы'"
                  :options="regionAreas"
                  :multiple="true"
                  :close-on-select="false"
                  :allow-empty="false"
                  :select-value="fields.actualAreas"
                  :checkbox-value="fields.actualAreasCheckbox"
                  :select-field="'actualAreas'"
                  :checkbox-field="'actualAreasCheckbox'"
                  @checkbox-change="activatedSelectChange"
                  @select-change="activatedSelectChange"
                  )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Справка из школы
                .form-elem__body
                  activated-select(
                  :placeholder="'Выберите районы'"
                  :options="regionAreas"
                  :multiple="true"
                  :close-on-select="false"
                  :allow-empty="false"
                  :select-value="fields.schoolAreas"
                  :checkbox-value="fields.schoolAreasCheckbox"
                  :select-field="'schoolAreas'"
                  :checkbox-field="'schoolAreasCheckbox'"
                  @checkbox-change="activatedSelectChange"
                  @select-change="activatedSelectChange"
                  )
      section.profile-page-form__section.profile-section(
      v-if="mode === 'edit'"
      ref="quotaHouseSection"
      )
        .profile-section__title
          h2.profile-section-title Корпус на квоту
        .profile-section__body
          .quotas-houses-registry
            .quotas-houses-registry__button
              button.button.button_paint-main--transparent(
                @click.prevent="onAddQuotasHouseButton"
              ) Добавить корпус
            .quotas-houses-registry__table
              manager-shifts-houses-registry-scroll-fix-table(
              :tab-head="housesTableHead"
              :tab-data="housesTableData"
              @on-edit-quota-house="onEditQuotaHouse"
              @on-delete-quota-house="onDeleteQuotaHouse"
              )
      section.profile-page-form__section.profile-section
        .profile-section__body
          .form
            .form__elem.form__elem_button
              .form-elem
                .form-elem__body
                  button.button.button_paint-main.button_long(
                  @click.prevent="onSaveQuota()"
                  )
                    .button__text Сохранить
                .form-elem__error(
                v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}

</template>

<script>
import {mapState, mapActions} from "vuex";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import ManagerShiftsHousesRegistryScrollFixTable from "./components/ManagerShiftsHousesRegistryScrollFixTable";
import QuotaHouseEditorModal from "../../../../../components/modals/QuotaHouseEditorModal";
import ActivatedSelect from "../../../../../components/activated-select/ActivatedSelect";
import Inputmask from "inputmask";
import LockableInput from "../../../../../components/lockable-input/LockableInput";
import QuotaCapacityModal from "../../../../../components/modals/QuotaCapacityModal";
export default {
  name: "ManagerQuotaEditor",
  components: {
    QuotaCapacityModal,
    LockableInput,
    ActivatedSelect,
    QuotaHouseEditorModal,
    ManagerShiftsHousesRegistryScrollFixTable,
    SimpleSelectForm,
    Inputmask
  },
  props: {
    houses: {
      type: Array,
      default: () => []
    },
    shiftData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showHouseEditor: false,
      extraOptionsValues: [
        {
          value: false,
          text: "Нет"
        },
        {
          value: true,
          text: "Да"
        }
      ],
      housesTableHead: [
        {
          title: "Корпус"
        },
        {
          title: "Цена"
        },
        {
          title: "Вместимость"
        }
      ],
      housesTableData: [],
      fields: {
        name: "",
        capacity: "",
        ageFrom: "",
        ageTo: "",
        gender: null,
        acquiringEnabled: false,
        registrationAreas: [],
        registrationAreasCheckbox: false,
        actualAreas: [],
        actualAreasCheckbox: false,
        schoolAreas: [],
        schoolAreasCheckbox: false
      },
      fieldsErrors: {
        name: {
          value: false,
          message: "Введите название квоты"
        },
        emptyCapacity: {
          value: false,
          message: "Введите количество людей"
        },
        wrongCapacity: {
          value: false,
          message: "Вместимость квоты не может превышать суммарную вместимость смены"
        },
        emptyAge: {
          value: false,
          message: "Введите возраст участников"
        },
        minAge: {
          value: false,
          message: "Минимальный возраст должен быть не менее 7 лет"
        },
        maxAge: {
          value: false,
          message: "Максимальный возраст должен быть не более 17 лет"
        },
        wrongAge: {
          value: false,
          message: "Неправильный диапазон возрастов участников"
        }
      },
      quotaData: null,
      currentHouse: null,
      errors: {},
      currentErrorMessage: "",
      capacityMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false,
        max: 32000
      }),
      ageMask: new Inputmask("integer", {
        placeholder: "",
        allowMinus: false,
        rightAlign: false
      }),
      showCapacityModal: false
    };
  },
  computed: {
    ...mapState(["regionAreas"]),
    mode() {
      if (this.$route.params.idQuota === "create") {
        return "create";
      }
      return "edit";
    },
    quotaId() {
      if (this.$route.params.idQuota && this.$route.params.idQuota !== "create") {
        return this.$route.params.idQuota;
      }
      return null;
    },
    ageError() {
      const arr = [
        "emptyAge",
        "minAge",
        "maxAge",
        "wrongAge"

      ];
      const index = arr.findIndex(field => {
        return this.fieldsErrors[field].value;
      });
      if (index === -1) {
        return false;
      }
      return true;
    }
  },
  methods: {
    ...mapActions([
      "getQuota",
      "updateQuota",
      "createQuota",
      "deleteQuotasHouse"
    ]),
    onEditQuotaHouse(house) {
      this.currentHouse = house;
      this.showHouseEditor = true;
    },
    onAddQuotasHouseButton() {
      this.currentHouse = null;
      this.showHouseEditor = true;
    },
    addQuotasHouse() {
      this.setQuota();
    },
    setQuota() {
      this.getQuota(this.quotaId).then(res => {
        this.quotaData = res;
        this.$root.$emit("on-hide-preloader");
      });
    },
    onDeleteQuotaHouse(house) {
      this.deleteQuotasHouse(house.id).then(res => {
        if (res.status === 204) {
          const index = this.quotaData.houses.findIndex(item => {
            return item.id === house.id;
          });
          this.quotaData.houses.splice(index, 1);
        } else {
          this.$root.$emit("onShowErrorModal", {
            text: res.data[0].message
          });
        }
      });
    },
    setFields(quotaData) {
      this.fields.name = quotaData.name;
      this.fields.capacity = quotaData.capacity;
      this.fields.ageFrom = quotaData.age_from;
      this.fields.ageTo = quotaData.age_to;
      this.fields.gender = quotaData.gender;
      this.fields.acquiringEnabled = quotaData.acquiring_enabled;

      this.fields.registrationAreas = quotaData.registration_areas;
      this.fields.registrationAreasCheckbox = quotaData.registration_areas.length > 0;
      this.fields.actualAreas = quotaData.actual_areas;
      this.fields.actualAreasCheckbox = quotaData.actual_areas.length > 0;
      this.fields.schoolAreas = quotaData.school_areas;
      this.fields.schoolAreasCheckbox = quotaData.school_areas.length > 0;

      this.housesTableData = quotaData.houses;
    },
    setErrors(data, status) {
      if (data.non_field_errors) {
        const code = data.non_field_errors[0].code;
        if (code === "invalid") {
          this.fieldsErrors.wrongCapacity.value = true;
          this.currentErrorMessage = this.fieldsErrors.wrongCapacity.message;
        }
      } else if (data.age) {
        this.currentErrorMessage = data.age[0].message;
        this.fieldsErrors.wrongAge.value = true;
      } else {
        this.$root.$emit("onShowErrorModal", {
          text: `${status} ошибка`
        });
      }
    },
    resetError(field) {
      const arr = field.split(",");
      arr.forEach(item => {
        this.fieldsErrors[item].value = false;
      });

      this.currentErrorMessage = "";
    },
    validation() {
      const errors = [];

      if (this.fields.name.length === 0) {
        errors.push("name");
      }
      if (this.fields.capacity.length === 0) {
        errors.push("emptyCapacity");
      }
      if (this.fields.ageFrom.length === 0 || this.fields.ageTo.length === 0) {
        errors.push("emptyAge");
      } else if (Number(this.fields.ageFrom) < 7) {
        errors.push("minAge");
      } else if (Number(this.fields.ageTo) > 17) {
        errors.push("maxAge");
      } else if (Number(this.fields.ageFrom) > Number(this.fields.ageTo)) {
        errors.push("wrongAge");
      }

      if (errors.length > 0) {
        errors.forEach(err => {
          this.fieldsErrors[err].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onSaveQuota() {
      if (!this.validation()) {
        return;
      };

      const areasFields = [
        {
          server: "registration_areas",
          checkbox: "registrationAreasCheckbox",
          select: "registrationAreas"
        },
        {
          server: "actual_areas",
          checkbox: "actualAreasCheckbox",
          select: "actualAreas"
        },
        {
          server: "school_areas",
          checkbox: "schoolAreasCheckbox",
          select: "schoolAreas"
        }
      ];

      const data = {
        name: this.fields.name,
        capacity: this.fields.capacity,
        age_from: this.fields.ageFrom,
        age_to: this.fields.ageTo,
        gender: this.fields.gender,
        acquiring_enabled: this.fields.acquiringEnabled
      };

      areasFields.forEach(field => {
        if (this.fields[field.checkbox] && this.fields[field.select].length === 0) {
          this.fields[field.checkbox] = false;
        }
        data[field.server] = this.fields[field.checkbox] ? this.fields[field.select].map(i => i.id) : [];
      });

      if (this.mode === "edit") {
        this.updateQuota({
          id: this.quotaId,
          data: data
        }).then(res => {
          if (res.status === 200) {
            this.quotaData = res.data;
            this.$root.$emit("onShowNotificationModal", {
              text: "Квота обновлена"
            });
            this.$router.push({
              name: "ManagerQuotasRegistry"
            });
          } else {
            this.setErrors(res.data);
          }
        });
      } else if (this.mode === "create") {
        data.campshift = this.shiftData.id;
        this.createQuota(data).then(res => {
          if (res.status === 201) {
            this.quotaData = res.data;
            this.$root.$emit("onShowNotificationModal", {
              text: "Квота создана. Теперь необходимо прикрепить корпус к данной квоте."
            });
            this.$router.replace(
              {
                name: "ManagerQuotaEditor",
                params: {
                  idQuota: res.data.id
                }
              },
              () => {
                this.$nextTick(function() {
                  this.$refs.quotaHouseSection.scrollIntoView(true);
                });
              }
            );
          } else {
            this.setErrors(res.data, res.status);
          }
        });
      }
    },
    activatedSelectChange(field, val) {
      this.fields[field] = val;
    },
    changeCapacity(val) {
      this.fields.capacity = val;
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    this.ageMask.mask(this.$refs.ageFrom);
    this.ageMask.mask(this.$refs.ageTo);
    if (this.mode === "edit") {
      this.setQuota();
    } else {
      this.capacityMask.mask(this.$refs.capacity);
      this.$root.$emit("on-hide-preloader");
    }
  },
  watch: {
    quotaData(val) {
      this.setFields(val);
    }
  }
};
</script>
